// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__0qO0e","sub_container":"WordGameLayout_sub_container__Bmg+N"};